// TODO generate on build from git tag
import { version } from "../package.json"

const [major, minor, patch] = version.split(".")
/**
 * An object carrying the SlashID SDK version information
 */
export const versionInfo = {
    major,
    minor,
    patch,
    raw: version,
}
